<template>
    <div class="pr-1">
        <c-card-iterator
            :items             = "filteredUnits"
            :label             = "title"
            :loading           = "loading"
            :title-prefix      = "true"
            :item-gap          = "0"
            :filter-height     = "user ? 330 : 286"
            :min-height        = "120"
            key-field          = "row"
            :zoom              = "false"
            :left-arrow        = "false"
            :refresh-on-filter = "false"
            :show-count        = "false"
            :enable-search     = "false"
            scroller-type      = "default"
            header-color       = "primary"
            ref                = "iterator"
        >
            <template v-slot:toolbar>
                <c-toolbar-button
                    v-if     = "filteredUnits && filteredUnits.length"
                    class    = "mr-3"
                    style    = "margin-top: -2px;"
                    icon     = "mdi-arrow-expand-vertical"
                    size     = "22"
                    color    = "white"
                    tooltip  = "Alle Adressen aufklappen"
                    @click   = "onExpandAll"
                />

                <c-toolbar-button
                    v-if     = "filteredUnits && filteredUnits.length"
                    class    = "mr-3"
                    style    = "margin-top: -2px;"
                    icon     = "mdi-arrow-collapse-vertical"
                    size     = "22"
                    color    = "white"
                    tooltip  = "Alle Adressen zusammenklappen"
                    @click   = "onCollapseAll"
                />

                <c-toolbar-button
                    v-if     = "filteredUnits && filteredUnits.length"
                    class    = "mr-3"
                    style    = "margin-top: -2px;"
                    icon     = "mdi-refresh"
                    size     = "22"
                    color    = "white"
                    :tooltip = "$t('disposition.order.refresh')"
                    @click   = "onRefresh"
                />
            </template>

            <template v-slot:filter>
                <div class="w-100 v-flex">
                    <div class = "lm-border pa-3 pb-6 w-50 mr-1" v-if="!order">
                        <v-row class="no-frame">
                            <v-col class="no-frame col-12">
                                <div class="pb-1">
                                    <v-text-field
                                        v-model        = "filter.order"
                                        label          = "Auftrag"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                        :clearable     = "true"
                                        @input         = "onFilter"
                                        hide-details
                                    />
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                    <div class="lm-border pa-3 pb-4" :class="!order ? 'w-50 ml-1' : 'w-100'">
                        <v-row class="no-frame">
                            <v-col class="no-frame col-6 pr-2">
                                <v-text-field
                                    v-model        = "filter.location"
                                    label          = "Adresse"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                    @input         = "onFilter"
                                    :clearable     = "true"
                                    hide-details
                                />
                            </v-col>

                            <v-col class="no-frame col-6 pl-2 pr-2">
                                <v-text-field
                                    v-model        = "filter.unit"
                                    label          = "Anlage"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                    @input         = "onFilter"
                                    :clearable     = "true"
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                        <v-row class="no-frame mt-3">
                            <v-col class="no-frame col-3 pr-2">
                                <v-text-field
                                    label          = "von PLZ"
                                    v-model        = "filter.zip.from"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                    :clearable     = "true"
                                    @input         = "onFilter"
                                    hide-details
                                />
                            </v-col>
                            <v-col class="no-frame col-3 pl-2 pr-2">
                                <v-text-field
                                    label          = "bis PLZ"
                                    v-model        = "filter.zip.to"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                    :clearable     = "true"
                                    @input         = "onFilter"
                                    hide-details
                                />
                            </v-col>
                        </v-row>

                        <v-row class="no-frame mt-3">
                            <v-col class="no-frame">
                                <v-switch
                                    label   = "geplante Begehungen (ohne Gutachter)"
                                    v-model = "filter.created"
                                    class   = "mt-4"
                                    :ripple = "false"
                                    @change = "onFilter"
                                    hide-details
                                    dense
                                >
                                </v-switch>
                            </v-col>
                        </v-row>

                        <v-row class="no-frame">
                            <v-col class="no-frame">
                                <v-switch
                                    label   = "zugeordnete Begehungen (mit Gutachter)"
                                    v-model = "filter.assigned"
                                    class   = "mt-4"
                                    :ripple = "false"
                                    @change = "onFilter"
                                    hide-details
                                    dense
                                >
                                </v-switch>
                            </v-col>
                        </v-row>

                        <v-row class="no-frame">
                            <v-col class="no-frame">
                                <v-switch
                                    label   = "Abgeschlossene Begehungen"
                                    v-model = "filter.closed"
                                    class   = "mt-4"
                                    :ripple = "false"
                                    @change = "onFilter"
                                    hide-details
                                    dense
                                >
                                </v-switch>
                            </v-col>
                        </v-row>

                        <v-row class="no-frame">
                            <v-col class="no-frame">
                                <v-switch
                                    :label  = "$t('disposition.inspection.deviceType.conflict.filter')"
                                    v-model = "filter.conflict"
                                    class   = "mt-4"
                                    :ripple = "false"
                                    @change = "onFilter"
                                    hide-details
                                    dense
                                >
                                </v-switch>
                            </v-col>
                        </v-row>

                        <v-row class="no-frame" v-if="user">
                            <v-col class="no-frame col-12">
                                <v-switch
                                    label   = "Begehungen des gewählten Gutachter"
                                    v-model = "filter.user"
                                    class   = "mt-4"
                                    :ripple = "false"
                                    @change = "onFilter"
                                    hide-details
                                    dense
                                >
                                </v-switch>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </template>

            <template v-slot:card="{ item }">
                <p-disposition-location-card
                    :order         = "order"
                    :location      = "item.data"
                    :assignments   = "assignments"
                    :selectable    = "isSelectable(item.data)"
                    :user          = "user"
                    :show-order    = "!order"
                    :selected      = "isSelected(item)"
                    :map-selected  = "mapSelected && mapSelected.id === item.data.id"
                    :assign-on     = "assignOn"
                    :dispatch-on   = "dispatchOn"
                    @site          = "onSite"
                    @assign        = "onAssign"
                    @assign-all    = "onAssignAll"
                    @deselect      = "onDissolve"
                    @dissolve-all  = "onDissolveAll"
                    @dispatch      = "onDispatch"
                    @dispatch-all  = "onDispatchAll"
                    @release       = "onRelease"
                    @release-all   = "onReleaseAll"
                    @selected      = "onSelected"
                    @expand        = "onExpand"
                    @collapse      = "onCollapse"
                    @locate        = "onLocate"
                />
            </template>
        </c-card-iterator>
    </div>
</template>

<script>

import Site                 from "@/modules/msd/unit/service/Site";
import Disposition          from "@/modules/dis/service/Disposition";
import CCardIterator        from "@/modules/core/components/utils/CCardIterator.vue";
import CToolbarButton       from "@/modules/core/components/utils/CToolbarButton.vue";
import PDispositionLocationCard from "@/modules/dis/components/order/location/private/PDispositionLocationCard.vue";
import Inspection from "@/modules/dis/service/inspection/Inspection";

export default {
    name: "PDispositionLocationCardIterator",

    components: {
        PDispositionLocationCard,
        CToolbarButton,
        CCardIterator,
    },

    props: {
        title: {

        },

        order: {
            required: false,
            type    : Object,
            default : function () {
                return null;
            }
        },

        /**
         *
         */
        data: {

        },

        user: {

        },

        loading: {
        },

        selected: {

        },

        /**
         * True, if the assign mode is switched on.
         */
        assignOn: {

        },

        /**
         * True, if the dispatch mode is switched on.
         */
        dispatchOn: {

        },

        all: {

        }
    },

    data: () => ({
        locations    : [],
        units        : null,
        assignments  : null,
        filteredUnits: null,
        mapSelected  : null,

        filter: {
            assignMode: false,
            created   : false,
            assigned  : true,
            closed    : false,
            user      : false,
            conflict  : false,
            location  : null,
            unit      : null,
            order     : null,

            zip: {
                from: null,
                to  : null
            },
        },
    }),

    watch: {
        data () {
            this.initialize(this.data.units, this.data.assignments)
        },

        user () {
            if (this.filter.user) {
                this.onFilter();
            }
        },

        assignOn () {
            if (this.assignOn) {
                this.filter.created = true;
            } else if (!this.dispatchOn) {
                this.filter.created = false;
            } else {
                return;
            }

            this.onFilter(false);
            if (this.assignOn) {
                this.onStartAssignMode();
                this.$nextTick().then(() => {
                    this.onCollapseAll();
                });
            } else {
                this.onEndAssignMode();
            }
        },

        dispatchOn () {
            if (this.dispatchOn) {
                this.filter.created = true;
            } else if (!this.assignOn) {
                this.filter.created = false;
            } else {
                return;
            }

            this.onFilter(false);
            if (this.dispatchOn) {
                this.filteredUnits = Disposition.inspection.list.expandAll(this.filteredUnits);
            }
        },
    },

    computed: {
        isAssignModePossible () {
            if (!this.assignOn) {
                return false;
            }

            if (!this.order || !this.order.id) {
                return false;
            }

            return this.order && !this.filter.assignMode;
        },
    },

    methods: {
        initialize (units, assignments) {
            this.$refs.iterator.onRemoveFilter();

            this.filter.assignMode = this.assignOn;
            this.filter.location = null;
            this.filter.user = false;
            this.filter.unit = null;
            this.filter.zip.from = null;
            this.filter.zip.to = null;
            this.units = units;

            this.assignments = assignments;
            this.locations = Disposition.inspection.list.groupByLocation(units);
            
            this.onFilter(this.filter.assignMode);

            if (this.dispatchOn) {
                this.$nextTick().then(() => {
                    this.onExpandAll();
                });
            }
        },

        scrollTo (unitId) {
            const location = this.locations.find(location => {
                const unit = location.units.find(unit => unit.id === unitId);
                return !!unit;
            });

            if (!location) {
                return null;
            }

            this.mapSelected = location;

            if (!location.expanded) {
                location.expanded = true;
                this.onExpand(location)
            }

            this.$refs.iterator.scrollTo(location.id);
            return location.units.find(unit => unit.id === unitId);
        },

        onRefresh () {
            this.$emit("refresh")
        },

        onSite (site) {
            if (site) {
                this.$emit("site", site)
            }
        },

        onStartAssignMode () {
            this.filter.assignMode = true;
            this.onFilter(true);
        },

        onEndAssignMode () {
            this.filter.assignMode = false;
            this.onFilter(true);
        },

        onFilter (collapse) {
            this.filteredUnits = Disposition.inspection.list.filter(
                this.filter,
                this.locations,
                this.user,
                collapse,
                this.dispatchOn
            );
            
            // Emit filtered units to parent for map synchronization
            this.$emit('filtered', this.filteredUnits);
        },

        onAssign (unit) {
            Disposition.order.assign.unit(this, this.order, this.location(unit), unit, this.user, this.assignments).then (() => {
              //  this.$nextTick().then(() => {
              //      this.onSelected(unit)
              //  })
            });
        },

        onAssignAll (location) {
            Disposition.order.assign.location(
                this,
                this.filteredUnits.find(u => u.id === location.id),
                this.order,
                this.user,
                this.assignments
            );
        },

        onDissolve (unit) {
            Disposition.order.dissolve.unit(
                this,
                this.order,
                this.location (unit),
                unit,
                this.assignments
            );
        },

        onDissolveAll (location) {
            Disposition.order.dissolve.location(
                this,
                this.filteredUnits.find(u => u.id === location.id),
                this.order,
                this.assignments
            );
        },

        onDispatch (unit) {
            Inspection.dispatch.inspection(
                this,
                this.location (unit),
                this.assignment (unit),
                this.user,
                this.assignments
            );
        },

        onDispatchAll (location) {
            if (!location.units || location.units.length === 0) {
                return;
            }

            Inspection.dispatch.location(
                this,
                this.filteredUnits.find(u => u.id === location.id),
                location.units[0].order,
                this.user,
                this.assignments
            );
        },

        onRelease (unit) {
            Inspection.release.inspection(
                this,
                this.location (unit),
                this.assignment (unit),
                this.assignments
            );
        },

        onReleaseAll (location) {
            const units = location.units;
            if (units && units.length > 0) {
                Inspection.release.location(this, location, units[0].order, this.assignments);
            }
        },

        onSelected (unit) {
            this.$emit("selected", {
                assignment: this.assignments.find(assignment => assignment.id === unit.inspectionId),
                unit      : unit
            });
        },

        onExpandAll () {
            if (!this.filteredUnits) {
                return;
            }

            this.filteredUnits = Disposition.inspection.list.expandAll(this.filteredUnits);
        },

        onCollapseAll () {
            Disposition.inspection.list.collapseAll(this.filteredUnits);
            this.onFilter()
        },

        onExpand (location) {
            Disposition.inspection.list.expand(location, this.filteredUnits);
        },

        onCollapse (location) {
            Disposition.inspection.list.collapse(location, this.filteredUnits);
        },

        onLocate (coords) {
            this.$emit("locate", coords);
        },

        isSelectable (unit) {
            return !(!unit || !unit.order);
        },

        /*
        refreshAssignment (assignment) {
            if (this.assignments) {
                Disposition.inspection.list.refresh(assignment, this.assignments);
                this.onFilter();
            }
        },

         */

        update (unit) {
            const index = this.units.findIndex (u => u.id === unit.id);
            if (index >= 0) {
                Site.unit(unit.id).then(unit => {
                    this.units[index] = unit;
                    this.onFilter();
                })
            }
        },

        setTechnician (inspection) {
            const assignment = this.assignments.find(a => a.unitId === inspection.unitId);
            if (assignment) {
                assignment.inspectionDate = inspection.inspectionDate;
                assignment.technicianId  = inspection.technicianId;
                assignment.technicianIdent = inspection.technicianIdent;
                assignment.technicianName = inspection.technicianName;
            }
        },

        location (unit) {
            return this.filteredUnits.find(u => u.id === unit.headerId);
        },

        assignment (unit) {
            return this.assignments.find(assignment => assignment.unit.id === unit.id && Inspection.list.sameOrder(assignment, unit));
        },

        isSelected (item) {
            if (this.selected && this.selected.id === item.data.id) {
                return Inspection.list.sameOrder(item.data, this.selected)
            }

            return false;
        }
    },
}
</script>

<style scoped>

::v-deep .vue-recycle-scroller.direction-vertical:not(.page-mode) {
    overflow-y: scroll;
}
</style>